import { UseFormReturn } from "react-hook-form"
import { EventFormData, CancellationPolicyType } from "@/types/events"
import { Label } from "@/components/ui/label"
import { Textarea } from "@/components/ui/textarea"
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group"
import { Switch } from "@/components/ui/switch"
import { Alert, AlertDescription } from "@/components/ui/alert"
import { Info } from "lucide-react"
import { useEffect } from "react"
import { DEFAULT_WHATS_INCLUDED } from "@/constants/forms"
import { CANCELLATION_POLICIES } from "@/constants/forms"

interface AdditionalDetailsFormProps {
  form: UseFormReturn<EventFormData>
}

export function AdditionalDetailsForm({ form }: AdditionalDetailsFormProps) {
  const { register, setValue, watch } = form
  const selectedPolicy = watch("cancellation_policy")

  useEffect(() => {
    setValue("whats_included", DEFAULT_WHATS_INCLUDED)
    setValue("host_included", true)
  }, [setValue])

  return (
    <div className="space-y-6">
      <div>
        <Label htmlFor="whats_included">What's Included</Label>
        <Textarea
          id="whats_included"
          placeholder="List what's included in this event..."
          className="mt-1.5"
          {...register("whats_included")}
        />
      </div>

      <div className="space-y-3">
        <Label>Cancellation Policy</Label>
        <RadioGroup
          value={selectedPolicy}
          onValueChange={(value: CancellationPolicyType) => {
            setValue("cancellation_policy", value)
            setValue("cancellation_terms", CANCELLATION_POLICIES.find(p => p.value === value)?.terms || "")
          }}
        >
          {CANCELLATION_POLICIES.map((policy) => (
            <div key={policy.value} className="flex items-center space-x-2">
              <RadioGroupItem value={policy.value} id={policy.value} />
              <Label htmlFor={policy.value}>{policy.label}</Label>
            </div>
          ))}
        </RadioGroup>
        {selectedPolicy && (
          <p className="text-sm text-muted-foreground mt-2">
            {CANCELLATION_POLICIES.find(p => p.value === selectedPolicy)?.terms}
          </p>
        )}
      </div>

      <div className="space-y-2">
        <div className="flex items-center space-x-2">
          <Switch
            id="host_included"
            checked={true}
            disabled={true}
            onCheckedChange={(checked) => setValue("host_included", checked)}
          />
          <Label htmlFor="host_included" className="text-muted-foreground">Host included</Label>
        </div>
        <Alert variant="info" className="bg-blue-500/10">
          <Info className="h-4 w-4" />
          <AlertDescription>
            Currently we support only host included events
          </AlertDescription>
        </Alert>
      </div>
    </div>
  )
}